import { useState } from 'react';
import { DataGridPro, getDefaultGridFilterModel, GridFilterModel } from '@mui/x-data-grid-pro';
import { useMediaQuery, useTheme } from '@mui/material';
import { itemLocationHistoryColumnDefinitions, mobileItemLocationHistoryColumnDefs } from './columns';
import { applyThemeGridSxOverrides } from '@/Infrastructure/Theme/AppThemeOverrides';
import { defaultFilterModel } from '@components/DataGrid/Dispatch/types';
import { GenericOverlay } from '@components/DataGrid/GenericNoRowsOverlay';
import { ItemLocationHistoryDataGridProps } from '@components/DataGrid/types';
import ItemLocationHistoryToolbar from './GridToolbar';

import styles from './DataGrid.ItemLocationHistory.module.css';

/**
 * MUI Data Grid Pro component for showing Item Location History.
 */
export default function Grid({ rows, consignmentId }: ItemLocationHistoryDataGridProps) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const [filterModel, setFilterModel] = useState<GridFilterModel>(defaultFilterModel);

	const handleLegSelected = (legId: number) => {
		setFilterModel(
			legId
				? {
						items: [
							{
								field: 'legId',
								operator: 'equals',
								value: String(legId)
							}
						]
					}
				: getDefaultGridFilterModel()
		);
	};

	return (
		<DataGridPro
			columns={isMobile ? mobileItemLocationHistoryColumnDefs : itemLocationHistoryColumnDefinitions}
			columnVisibilityModel={{
				legId: false
			}}
			filterModel={filterModel}
			columnHeaderHeight={50}
			rowHeight={isMobile ? 140 : 50}
			rows={rows}
			getRowClassName={(props) => (props.indexRelativeToCurrentPage % 2 ? styles['alternate-row'] : '')}
			slots={{
				toolbar: ItemLocationHistoryToolbar,
				noRowsOverlay: () => <GenericOverlay overlayText='No Item Location History Found.' />
			}}
			slotProps={{
				toolbar: {
					itemLocationHistoryToolbarOverrides: {
						consignmentId,
						onLegSelected: handleLegSelected
					}
				}
			}}
			sx={{
				...applyThemeGridSxOverrides(),
				'& .MuiDataGrid-columnHeaders': isMobile
					? {
							display: 'none'
						}
					: {}
			}}
		/>
	);
}
